<template>
    <div class="input-content">
        <div class="user-input-textarea-wrapper" ref="user-input-textarea-wrapper">
            <a-mentions
                rows="5"
                autoFocus
                v-model="prompt"
                :prefix="['/']"
                :disabled="typing"
                class="user-input-textarea" :placeholder="placeholder"
                @keydown.native.alt.enter.prevent="wrap"
                @select="selectValue"
                @blur="handleFocus(false)"
                @focus="handleFocus(true)"
                @keydown.native.enter.prevent.exact="ask"
                :getPopupContainer="() => $refs['user-input-textarea-wrapper']">
                <a-mentions-option :value="item.title" :key="item.value" v-for="item in mentionsList">
                    {{ item.title }}
                </a-mentions-option>
            </a-mentions>
        </div>
        <div class="textarea-right">
            <mic :prompt.sync="prompt"></mic>
            <img class="send" :class="{'disabled': !prompt}" src="@/theme/images/icons/icon_send.svg" @click="send()" title="发送" />
        </div>
    </div>
</template>

<script>
import mic from './mic.vue';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';
import historyAPI from '@/api/history.api';
import { timeToString } from '@/utils/time';
import { isJson } from '@/utils/json.js';
export default {
    name: 'gpt-chatbox-service',
    components: { mic },
    data () {
        let { protocol, host } = window.location;
        return {
            prompt: '',
            recording: false,
            wsSERVER: `${protocol === 'https:' ? 'wss' : 'ws'}://${host}/websocket/getAnswer/`,
            MODEL_LIST,
            socket: null,
            answer: '',
            timeOut: null,
            isEnd: false,
            isSending: false,
            interval: null
        };
    },
    props: {
        /**
         * 是否正在输入
         */
        typing: {
            type: Boolean,
            default: false
        },
        /**
         * 输入框的占位文字
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * 输入框的内容
         */
        input: {
            type: String,
            default: ''
        },
        /**
         * SessionID
         */
        sessionId: {
            type: String,
            default: ''
        },
        modelSettings: {
            type: Object,
            default: null
        }
    },
    computed: {
        mentionsList () {
            return [
                ...this.MODEL_LIST
            ];
        }
    },
    watch: {
        input (val) {
            this.prompt = val;
        },
        prompt (val) {
            if (val && val[0] === '/') {
                this.$emit('showModel');
            }
            if (val && val.indexOf('/?') > -1) {
                this.$bus.$emit('openAiModel');
                this.prompt = this.prompt.replace('/?', '');
            }
        }
    },
    async mounted () {
        this.prompt = this.input;
        this.$bus.$on('newChat:reflash', (data) => {
            this.initSocket();
        });
        this.$bus.$on('shop:thisWs', (data) => {
            this.socket.close();
            this.prompt = '';
        });
    },
    methods: {
        handleFocus (focus) {
            this.$emit('focus-typing', focus);
        },
        send () {
            if (this.isSending) {
                return;
            }
            if (this.prompt.trim() === '') {
                this.$message.error('请输入内容后再发送');
                return;
            }
            this.isSending = true;
            const paramsData = {
                ask: {
                    question: this.prompt,
                    station: '天河智慧城'
                },
                type: 'TEXT',
                useLLM: this.$store.state.appSettings.useLLM,
                bizType: 'intel-customer',
                contextLimit: this.modelSettings ? this.modelSettings.contextLimit : 3,
                temperature: this.modelSettings ? this.modelSettings.temperature : 0.05,
                maxLength: this.modelSettings ? this.modelSettings.maxLength : 2048
            };
            if (this.socket && this.socket.readyState === 1) {
                this.socket.send(JSON.stringify(paramsData));
            } else {
                this.initSocket(() => {
                    this.socket.send(JSON.stringify(paramsData));
                });
            }
        },
        ask (event) {
            if (event && !event.altKey) {
                this.send();
            }
        },
        wrap (event) {
            if (event.altKey) {
                this.prompt = this.prompt + '\n';
            }
        },
        selectValue (data) {
            this.$emit('setModel', data.value);
            this.prompt = this.prompt.replace(`/${data.value}`, '');
        },
        initSocket (cb) {
            if (this.socket && this.socket.connected) this.socket.close();
            this.socket = new WebSocket(`${this.wsSERVER}${this.sessionId}`);
            // socket = new WebSocket(`ws://172.29.20.34:11111/llm/intel-customer/${sessionid}`);

            this.socket.onopen = () => {
                console.info('gpt-chatbox-service WebSocket连接已打开');
                if (cb) {
                    return cb();
                }
                if (this.interval) {
                    clearInterval(this.interval);
                }
                // this.interval = setInterval(() => {
                //     this.socket.send('ping');
                // }, 30000);
            };

            this.socket.onclose = () => {
                console.info('gpt-chatbox-service WebSocket连接发生关闭');
                this.isSending = false;
            };

            this.socket.onmessage = (event) => {
                if (event.data === 'pong') {
                    return;
                }
                let str = '';
                if (isJson(event.data)) {
                    str = JSON.parse(event.data).answer.toString();
                } else {
                    str = event.data.toString();
                }
                if (str.trim() === 'start' || str.trim() === 'Start') {
                    this.answer = '';
                    this.isEnd = false;
                    this.$emit('thinkAsk', { content: '', type: 'start', input: this.prompt });
                    this.prompt = '';
                } else if (str === '[DONE]' || str === '[done]') {
                    // socket结束后告诉父组件loading该暂停了
                    if (!this.isEnd) {
                        this.$emit('thinkAsk', { content: '', type: '[done]', input: this.prompt, answer: this.answer });
                        this.isEnd = true;
                        clearTimeout(this.timeOut);
                        this.timeOut = null;
                        this.isSending = false;
                        this.socket.close();
                    }
                    this.prompt = '';
                } else if (str !== 'CONNECT_SUCCESS') {
                    // this.$emit('thinkAsk', { content: this.prompt, url: `${this.wsSERVER}${this.sessionId}`, bizType: 'intel-customer' });
                    this.$emit('thinkAsk', { content: str, type: '' });
                    this.answer = this.answer + str;
                    if (this.timeOut) {
                        clearTimeout(this.timeOut);
                        this.timeOut = null;
                    }
                    if (!this.isEnd) {
                        this.timeOut = window.setTimeout(() => {
                            this.$emit('thinkAsk', { content: '', type: '[done]', input: this.prompt, answer: this.answer });
                            this.isEnd = true;
                            this.prompt = '';
                            this.isSending = false;
                            this.socket.close();
                        }, 3000);
                    }
                }
            };
        }
    },
    beforeDestroy () {
        if (this.socket) {
            this.socket.close();
        }
        this.$bus.$off('newChat:reflash');
        this.$bus.$off('shop:thisWs');
        if (this.interval) {
            clearInterval(this.interval);
        }
    }
};
</script>

<style scoped lang="scss">
@import './gpt-chatbox-common.scss';
</style>
